import { create } from 'zustand';

interface OrganizationDetailState {
  isEditMode: boolean;
  isDirty: boolean;
  setIsEditMode: (isEditMode: boolean) => void;
  setIsDirty: (isDirty: boolean) => void;
}

const useOrganizationDetailStore = create<OrganizationDetailState>((set) => ({
  isEditMode: false,
  isDirty: false,
  setIsEditMode: (isEditMode) => set({ isEditMode }),
  setIsDirty: (isDirty) => set({ isDirty }),
}));

export default useOrganizationDetailStore;
